import { Link } from "react-router-dom";
import Footer from "../components/Footer.tsx";
import { ROUTE_LOGIN, ROUTE_REGISTER } from "../const/routes";
import InputBox from "../components/core/InputBox";
import RegisterForm from "../components/auth/form/RegisterForm.tsx";
import SEO from "../components/core/SEO.tsx";
import { useLayoutEffect } from "react";

const Register = () => {
  useLayoutEffect(() => {
    scrollTo({ top: 0 });
  }, []);
  return (
    <div className="safe-bottom-with-dock bg-base-100 text-base-content min-h-screen ">
      <SEO title="Register" url={ROUTE_REGISTER} noIndex />

      <div className="relative flex flex-col items-center bg-[url(/background.png)] bg-[50%_20%] lg:bg-[60%_50%] bg-cover">
        <div className="absolute inset-0 bg-gradient-to-b from-info/60 via-accent/20 to-base-300" />
        <main className="flex justify-center items-center grow max-w-2xl w-full h-screen md: p-0 p-1">
          <InputBox>
            <div className="grid gap-4">
              <fieldset className="fieldset">
                <h2 className="fieldset-legend text-xl p-2">Registrieren</h2>
                <RegisterForm />
              </fieldset>
              <br />
              <div className="flex items-center text-right justify-end gap-2">
                <label className="grow self-center">
                  Du hast ein Konto? Hier{" "}
                  <Link className="link" to={ROUTE_LOGIN}>
                    anmelden
                  </Link>
                  .
                </label>
              </div>
            </div>
          </InputBox>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
